import { ApiError, ErrorResponseDto } from '@pro4-erp/core-web';
import env from '@/env';
import { VisitProductNC } from '../types';

export const getVisitProducts = async (id: string): Promise<VisitProductNC[]> => {
  const fetchResponse = await fetch(
    `${env.VITE_API_URL}/pb/s/api/sqo-portal/auditor-visits/products-nextcloud/${id}`,
    {
      method: 'GET',
      headers: {
        authenticate: localStorage.getItem('accessToken') || '',
      },
    }
  );

  if (!fetchResponse.ok) {
    const error = (await fetchResponse.json()) as ErrorResponseDto;
    throw new ApiError(error);
  }

  const response = (await fetchResponse.json()) as VisitProductNC[];
  return response;
};
